import { FieldArrayRenderProps } from "formik";
import { UserSkill } from "src/types/skill";
import { SkillsDefaults } from "./constants";
import { QueueRoutingType } from "src/types/routingType";

export const setRowIdForUserSkills = (userSkills: UserSkill[]) => {
	userSkills.forEach((x: UserSkill) => {
		x.rowId = x.id;
	});
};

export const addUserSkill = (
	arrayHelpers: FieldArrayRenderProps,
	skillId: string,
	userId: string
) => {
	const newUserSkill: UserSkill = {
		skillId: skillId,
		userId: userId,
		skillLevel: SkillsDefaults.SkillLevel,
		rowId: `${Math.random()}`,
	};
	arrayHelpers.push(newUserSkill);
};

export const reorderEnumValues = (array: QueueRoutingType[], areSkillsEnabled: boolean) => {
	if (!areSkillsEnabled) {
		array = array.filter((x) => x !== QueueRoutingType.SkillBasedRouting);
	}

	array[0] = array.splice(1, 1, array[0])[0];

	return array;
};
